import { useState } from "react";

export const useControlActionBarVisible = () => useState(false);